import { render } from "./MyAccountSidebar.vue?vue&type=template&id=2b4cbe5e"
import script from "./MyAccountSidebar.vue?vue&type=script&lang=js"
export * from "./MyAccountSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__